import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import PrimeTrade from "./pages/PrimeTrade";
import Catalog from "./pages/Catalog";
import CategoryDetail from "./pages/CategoryDetail";
import Partners from "./pages/Partners";
import Gallery from "./pages/Gallery";
import Contacts from "./pages/Contacts";
import { Toaster } from "./components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/company" element={<About />} />
          <Route path="/company/prime-trade" element={<PrimeTrade />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/catalog/:slug" element={<CategoryDetail />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contacts" element={<Contacts />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
